import { createAction, props } from '@ngrx/store';
import { BLOCK_LIST, BlockTypes } from '@app/newsletter-new/models/block-type.enum';

export const setFreezeBlocked = createAction(
  '[FreezeBlock] Set Blocked',
  props<{ blocked: boolean }>()
);

export const setUserHasWriteAccessPermission = createAction(
  '[FreezeBlock] Set user have permission',
  props<{ userHasWriteAccessPermission: boolean }>(),

);

export const setHiddenContentBlocks = createAction(
  '[FreezeBlock] Set hide content blocks',
  props<{ newsletterContentBlocksHidden: string[] }>(),

);
